<template src="./add-video.html"></template>

<script lang="ts">
import addVideoLinkService from 'services/api/add-video-link'
import domUtils from 'util/dom-utils'
import { Media, RestError } from 'services/api-service'
import PageLoadingMixin from 'mixins/PageLoadingMixin.vue'
import ProductImage from 'objects/product-image/ProductImage.vue'
import ReviewFlowFooter from '../ReviewFlowFooter.vue'
import Header from 'objects/header/Header.vue'
import ReviewFlowProduct from '../ReviewFlowProduct.vue'
import TextField from 'objects/form/TextField.vue'
import submissionStore, { SubmissionPage } from 'store/submission-store'
import { TYPE_VIDEO } from 'util/media-utils'



const YOUTUBE_LINK_REGEX =
  /^(http(s)?:\/\/)?((www|m)\.)?(youtube.com|youtu.be)\/(watch|embed)?(\?v=|\/)?(\S+)?/

export default {
  name: 'AddVideo',
  data() {
    return {
      errorText: '',
      isSubmitting: false,
      submissionStoreState: submissionStore.state,
      videoLink: ''
    }
  },
  emits: ['showError'],
  components: {
    'tt-product-image': ProductImage,
    'tt-review-flow-footer': ReviewFlowFooter,
    'tt-header': Header,
    'tt-review-flow-product': ReviewFlowProduct,
    'tt-text-field': TextField
  },
  mixins: [PageLoadingMixin],
  computed: {
    catItem() {
      return this.submissionStoreState.catItem
    },
    isValidLink() {
      const trimmedLink = this.videoLink.trim()
      return trimmedLink.length > 0 && YOUTUBE_LINK_REGEX.test(trimmedLink)
    },
    siblingSiteKey() {
      return submissionStore.siblingSiteKey
    }
  },
  methods: {
    add() {
      this.isSubmitting = true
      // This should not happen since button should not be enabled, but just in case
      if (!this.isValidLink) {
        this.errorText = this.$msg('addVideo.invalidLink')
        this.focusField()
        this.isSubmitting = false
        return
      }
      this.errorText = ''
      addVideoLinkService.addVideoLink({
        url: this.videoLink
      }).then((videoDetails) => {
        // add other media properties
        (videoDetails as Media).type = TYPE_VIDEO
        submissionStore.currentPage = {
          page: 'add-captions',
          props: { video: videoDetails }
        } as SubmissionPage
      }).catch((e: RestError) => {
        if (e.errorCode === 'media-provider-unsupported') {
          this.errorText = this.$msg('addVideo.notSupportedService')
        } else if (e.errorCode === 'media-file-not-authorized') {
          this.errorText = this.$msg('addVideo.hiddenVideoError')
        } else if (e.errorCode === 'media-file-not-found') {
          this.errorText = this.$msg('addVideo.videoNotFoundError')
        } else {
          this.$emit('showError', this.$msg('unexpected.error'), false)
        }
        this.focusField()
        this.isSubmitting = false
      })
    },
    back() {
      submissionStore.currentPage = {
        page: submissionStore.previousPage.page,
        props: { mediaBtnFocus: TYPE_VIDEO }
      }
    },
    focusField() {
      domUtils.safeFocus(() => this.$el.querySelector('input'))
    }
  },
  created() {
    // event fired from wrapping component (submission modal) when the user clicks modal close
    // or presses esc
    submissionStore.eventBus.on('back', this.back)
  },
  mounted() {
    // calling PageLoadingMixin
    this.pageLoaded(true)
    this.focusField()
  }
}
</script>

<style lang="scss" src="./add-video.scss"></style>
